export const APP_INITIALIZATION_LOADER_MESSAGE = 'Loading ...'
